module.exports = __webpack_public_path__ + "img/sobre-nos.c78c2a59.svg";